<template>
 <div
    v-if="datasReady"
    class="qw-box"
  >
    <div class="alloication-tip-t">
      <a-alert
        :message="webhookTip"
        type="info"
        show-icon
      />
    </div>
    <div class="qw-op-box">
      <div
        v-if="qWData.bindcomname && qWData.bindcomname.length>0"
        class="has-bind-tip"
      >
        <div class="tit">
          <i class="qwdd-icon" />{{ $t('message["1450"]') }}：
        </div>
        <ul>
          <li
            v-for="(item, index) in qWData.bindcomname"
            :key="index"
          >
            <strong>{{ item }}</strong>
            <a
              href="javascirpt:;"
              class="del-btn-a ml-16"
              @click="closeQw"
            >{{ $t('message["403"]') }}</a>
          </li>
        </ul>
        <close-qw-dialog
          ref="closeDialog"
          type="qw"
        />
      </div>
      <div
        v-if="qWData.isbind *1 ===0 || qWData.bindcomname.length < 2 "
        class="qw-install-box"
      >
        <a
          class="ant-btn ant-btn-primary"
          :href="qWData.installurl"
        >{{ $t('message["2"]') }}</a>
        <span class="qw-install-tip">{{ $t('message["1719"]') }}</span>
      </div>
    </div>
    <div class="p-tip-box">
      <i class="icon iconfont icon-tips-info1" />
      <div class="p-tip-con">
        {{ $t('message["951"]') }}：
      </div>
      <ol class="qw-top-tip">
        <li>• {{ $t('message["636"]') }}</li>
        <li>• {{ $t('message["316"]') }}</li>
      </ol>
    </div>
    <div class="qwdd-tit">
      <h2>{{ $t('message["726"]') }}</h2>
    </div>
    <div class="qw-show">
      <ul class="clearfix">
        <li style="background:url('//img-i.gcimg.net/2018/1210/cc0q0ujgxv4c3ac7071339.jpg') 0 0 no-repeat; background-size:360px 640px;" />
        <li style="background:url('//img-i.gcimg.net/2018/1210/i9u93l9pydexffc4071339.jpg') 0 0 no-repeat; background-size:360px 640px;" />
        <li style="background:url('//img-i.gcimg.net/2018/1210/lu750isltiszedbs071339.jpg') 0 0 no-repeat; background-size:360px 640px;" />
      </ul>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import CloseQwDialog from '@/components/pc/organization/CloseQwDialog'
export default {
  components: {
    // Ddm,
    // Qw
    CloseQwDialog
  },
  data () {
    return {
      current: '1'
    }
  },
  computed: {
    ...mapState('organization/qw', ['datasReady', 'qWData']),
    cid () {
      return this.$route.query.cid
    },
    webhookTip () {
      return this.$t('message["1718"]')
    }
  },
  async mounted () {
    const chain = await this.getQw()
    chain.params({ cid: this.cid })
      .fetch()
    // const chain2 = await this.getDd()
    // chain2.params({ cid: this.cid })
    //   .fetch()
  },
  methods: {
    ...mapActions('organization/qw', ['getQw', 'getDd']),
    closeQw () {
      this.$refs.closeDialog.changeLimitDialog(true)
    }
  }
}
</script>
<style lang="scss" scoped>
  .qw-box::v-deep {
    position: relative;
    margin-bottom: 24px;
  .del-btn-a {
    padding: 0 12px;
    height: 30px;
    border-radius: 4px;
    border: solid 1px #f57676;
    background-color: #f57676;
    color: #fff;
    display: inline-block;
    line-height: 30px;
    margin-left: 16px;
  }
    .p-tip-con {
      font-weight: 600;
    }

    .qw-show {
      width: 1230px;
      overflow: hidden;

      ul {
        width: 1254px;

        li {
          width: 360px;
          height: 640px;
          margin-right: 58px;
          background: blue;
          float: left;
        }
      }
    }

    .p-tip-box {
      .qw-top-tip {
        padding-top: 8px;
        color: #666;

        li {
          line-height: 24px;
          font-weight: bold;
        }
      }
    }

    .qw-op-box {
      margin: 6px 0 24px;
      .mtp{
         margin-top: 24px;
      }
      .qw-install-box {
        .ant-btn-primary {
          margin-right: 8px !important;
        }
        span {
          color: #999;
        }
      }
      .has-bind-tip {
        line-height: 32px;
        min-height: 32px;
        position: relative;
        padding-left: 106px;
        .tit {
          position: absolute;
          left: 0;
          font-size: 18px;
          font-weight: bold;
        }
        li {
          margin-bottom: 16px;
        }
        strong {
          font-size: 18px;
        }

        .qwdd-icon {
          width: 24px;
          height: 24px;
          display: inline-block;
          background: url('//img-i.gcimg.net/2018/1210/eidgckrcf8wl7b40075807.png') no-repeat 0 0;
          background-size: 24px 24px;
          vertical-align: middle;
          margin-right: 10px;
        }
      }
    }

    .qwdd-tit {
      padding: 16px 0 16px;
      border-top: 1px solid #ebebeb;
      margin-top: 24px;

      h2 {
        font-weight: bold;
        line-height: 24px;
        font-size: 14px;
      }
    }
  }
   .alloication-tip-t::v-deep {
    margin-bottom: 24px;
    padding-top: 8px;
    .ant-alert-warning{
      background: #FFF4E7;
      border: 1px solid #F6A953;
      border-radius: 4px;
    }
  }
</style>
